<script>
import HorizontalMenu from '@/components/general/HorizontalMenu'
import Breadcrumbs from '@/components/general/Breadcrumbs'
export default {
  name: 'Payment',
  components: {
    HorizontalMenu,
    Breadcrumbs
  },
  data () {
    return {
      selectedMenu: 0,
      menuOptions: [
        { to: { name: 'business.admin.center.payment.credits' }, text: 'admin.center.payment:menu.credits' }
      ]
    }
  },
  computed: {
    breadcrumbsPaths () {
      const path = [{ text: 'admin.center:menu.7:title', href: this.$route.path }]
      return path
    }
  },
  created () {
    this.selectedWorkspace.region === 'BRA' && this.menuOptions.push({ to: { name: 'business.admin.center.payment.other.services' }, text: 'admin.center.payment:menu.other.services' })
  }
}
</script>
<template>
  <section class="payment--container center-small">
    <div class="default-header">
      <breadcrumbs :items="breadcrumbsPaths"/>
      <h2>{{ $t('admin.center:payment.title') }}</h2>
    </div>
    <horizontal-menu :options="menuOptions" v-model="selectedMenu"></horizontal-menu>
    <router-view></router-view>
  </section>
</template>
<style lang="scss">
.payment--container {
  .horizontal-menu--container {
    margin-bottom: 8px;
  }
}
</style>
